export { ModalComponent } from './Modal'
